import { Construction, ArrowRight } from 'lucide-react';

function PlaceholderPage({ title, department }) {
  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid={`placeholder-${title.toLowerCase().replace(/\s+/g, '-')}`}>
      <div className="text-center max-w-md">
        {/* Icon */}
        <div className="mb-6 inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-[#e65100]/10 to-[#f57c00]/10 rounded-2xl">
          <Construction className="text-[#e65100]" size={40} />
        </div>
        
        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-900 mb-2">{title}</h1>
        <p className="text-gray-500 mb-6">
          This page is part of the <span className="font-semibold text-[#1a237e]">{department}</span> department and will be configured soon.
        </p>
        
        {/* Info Card */}
        <div className="bg-gradient-to-r from-indigo-50 to-blue-50 border border-indigo-100 rounded-xl p-5 text-left">
          <h3 className="font-semibold text-[#1a237e] mb-2">Coming Soon</h3>
          <p className="text-sm text-gray-600 mb-3">
            This module is being developed. You can provide specific requirements for this page.
          </p>
          <div className="flex items-center text-sm text-[#e65100] font-medium">
            <span>Share your requirements</span>
            <ArrowRight size={16} className="ml-1" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlaceholderPage;
